import { useCallback, useEffect, useState } from "react";
import { Dropdown } from "../core/form/Dropdown";
import { DynamicDropdownElement, EventContext, useContainer, usePresenter, usePresenterEvents } from "./types";
import { DataMessages } from "../core/hooks/useData";

export function DynamicDropdown(props: {
	def: DynamicDropdownElement,
}) {
	const presenter = usePresenter();
	const container = useContainer();

	const [items, setItems] = useState([]);

	useEffect(() => {
		// initial load of items
		getItems();
	}, []);

	function getItems() {
		const ctx: EventContext = {
			container,
			dataWindows: [{
				name: "data",
				obj: container.data,
			}],
			def: props.def,
			presenter,
			type: "change",
			options: container.options,
			debugContext: [
				"DynamicDropdown.change",
			]
		};
		if (props.def.getOptionsScript) {
			const items = presenter.scriptEngine.run(props.def.getOptionsScript, ctx);

			for(let i of items) {
				if (i.title && i.title.indexOf("\n") >= 0) {
					i.title = <span style={{whiteSpace: "pre", textAlign: "left"}}>{i.title}</span>;
				}
			}

			setItems(items);
		}
	}

	usePresenterEvents(
		presenter, 
		useCallback((msg: any) => {
			if (msg.type === DataMessages.CHANGE) {
				getItems();
			}
		}, [presenter]),
	);

	return (
		<Dropdown
			prop={props.def.id}
			items={items}
			getDisplay={(item: any) => item.title}
			getValue={(item: any) => item.id}
			multiSelect={props.def.multiSelect}
			oneSelectionAtTime={props.def.oneSelectionAtTime}
			renderSelection={(selected: any[]) => {
				const result = [];
				let i = 0;
				for(let o of selected) {
					result.push(
						<div className="option padding-2 tag selected-option" key={i++}>
							{o.title}
						</div>
					);
				}
				return (
					<div className="flex horiz wrap gap-2">
						{result}
					</div>
				);
			}}
		/>
	);
}